import { memo } from "react";
import TextCursor from "../TextCursor";
import PERSONAL_INFO from "../../../../constants/personal-info.json";
import styles from "./About.module.scss";
import { ReactComponent as UnderlineSvg } from "../../../../assets/images/underline.svg";

function About() {
  const renderCategory = (category: any) => {
    return (
      <div key={category.title} className={styles.category}>
        <span className={styles.category__title}>{category.title}</span>
        <span className={styles.category__item}>{category.value}</span>
      </div>
    );
  };

  return (
    <div className={styles.about}>
      <section>
        <div className={styles.header}>
          <TextCursor>
            <span>About me</span>
          </TextCursor>
          <UnderlineSvg className={styles.underline} />
        </div>
        <TextCursor>
          <div className={styles.list}>{PERSONAL_INFO.map(renderCategory)}</div>
        </TextCursor>
      </section>
    </div>
  );
}

export default memo(About);
